import moment from 'moment-timezone';

import { EventsFilter } from '../interfaces';
import { initialEventFiltersState } from '../reducers/eventFilters/eventFiltersState';
import { EventTypeIdentifier, VideoStatus } from '../enums';

const fleetToFilterMap = new Map<number, Partial<EventsFilter>>([
  [
    1, // MTA
    {
      dateFrom: moment().subtract(7, 'day').startOf('day').toISOString(),
      dateTo: moment().toISOString(),
      selectedFilters: [EventTypeIdentifier.BUS_LANE_MATCH],
      human_review: true,
      media_statuses: [VideoStatus.publishedStr],
      whitelist: false,
    } as Partial<EventsFilter>,
  ],
  [
    40, // MTA Replay
    {
      dateFrom: moment().subtract(7, 'day').startOf('day').toISOString(),
      dateTo: moment().toISOString(),
      selectedFilters: [EventTypeIdentifier.BUS_LANE_MATCH],
      human_review: true,
      media_statuses: [VideoStatus.publishedStr],
      whitelist: false,
    } as Partial<EventsFilter>,
  ],
  [
    2256, // SacRT Bus Stop Shelter
    {
      dateFrom: moment().subtract(24, 'hours').toISOString(),
      dateTo: moment().toISOString(),
      include_tags: true,
      tag_operator: 'or',
      tags: {
        'td:776': 'ev:2233', // Graffiti SacRT bus stop shelter tags
        'td:772': 'ev:2230', // 'Sign missing/faded',
        'td:781': 'ev:2238', // 'Faded / missing advertisements',
        'td:774': 'ev:2231', // 'Pole is broken / missing',
        'td:775': 'ev:2232', // 'Broken glass',
        'td:777': 'ev:2234', // 'Lights out',
        'td:778': 'ev:2235', // 'Garbage overflow',
        // 'td:779': 'ev:2236', // 'Good condition',
        'td:780': 'ev:2237', // 'Other',
        'td:814': 'ev:2271', // Unattended Personal Property
      },
    },
  ],
]);

export const fleetDefaultFilters = (fleetId: number): Partial<EventsFilter> => {
  if (fleetToFilterMap.has(fleetId)) {
    return { ...initialEventFiltersState.filter, ...fleetToFilterMap.get(fleetId) };
  }
  return { ...initialEventFiltersState.filter };
};

export const fleetCleanFilters = (): Partial<EventsFilter> => {
  return { ...initialEventFiltersState.filter };
};
